export default __webpack_public_path__ + "static/media/congratulations.e8ab3ef8.svg";